import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import config from '../config/config'
import ManageItemAddPhotos from '../components/ManageItemAddPhotos'
import ManageItemPhotosList from '../components/ManageItemPhotosList'
import { setFlashMessage } from '../contexts/WebsiteContext'
import PoiTechnicalSheet from '../components/PointOfInterest/PoiTechnicalSheet'
import ProductTechnicalSheet from '../components/ProductTechnicalSheet'

const ManageProductPhotos = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const [product, setProduct] = useState(null)
  const [refreshList, setRefreshList] = useState()

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}product/${id}`)
        setProduct(response.data)
      } catch (error) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('Erreur lors de la récupération du product ', { id })
      }
    }

    fetchProduct()
  }, [id, t])

  const handleAddPhotos = () => {
    setRefreshList(!refreshList)
  }

  const handleUpdatePhotoRanking = () => {
    setRefreshList(!refreshList)
  }

  return (
    <div>
      <NavigationBar />
      <h1>{t('MANAGE_PHOTOS')}</h1>
      {product && <ProductTechnicalSheet product={product} />}
      {product && (
        <ManageItemAddPhotos
          item={product}
          itemType={'PRODUCT'}
          handleAddPhotos={handleAddPhotos}
        />
      )}
      {product && (
        <ManageItemPhotosList
          item={product}
          itemType={'PRODUCT'}
          refreshList={refreshList}
          handleUpdatePhotoRanking={handleUpdatePhotoRanking}
        />
      )}
      <Footer />
    </div>
  )
}

export default ManageProductPhotos
